import React, { useState, useEffect } from "react";

const Pagination = ({ showPerPage, onPaginationsChange, totalContent }) => {
  const [counter, setCounter] = useState(1);
  const [countker, setCountker] = useState(0);

  useEffect(() => {
    const value = showPerPage * counter;
    onPaginationsChange(value - showPerPage, value);
  }, [counter]);

  const onButtonClick = (type) => {
    if (type === "prev") {
      if (counter === 1) {
        setCounter(1);
      } else {
        setCounter(counter - 1);
        disableMttKaro();
      }
    } else if (type === "next") {
      setCounter(counter + 1);
      disableKaro();
    }
  };

  function disableKaro() {
    console.log(totalContent / showPerPage);
    let content = Math.ceil(totalContent / showPerPage);
    setCountker(content - counter);
  }
  function disableMttKaro() {
    let content = Math.ceil(totalContent / showPerPage);
    setCountker(content + counter);
  }

  return (
    <div style={{ display: `${totalContent === 0 ? "none" : "block"}` }}>
      <div className="d-flex justify-content-between">
        <button
          type="button"
          class="btn btn-warning"
          onClick={() => onButtonClick("prev")}
          disabled={counter === 1 ? true : false}
        >
          Previous
        </button>
        <button
          type="button"
          class="btn btn-warning"
          disabled={
            countker === 1 || totalContent <= showPerPage ? true : false
          }
          onClick={() => onButtonClick("next")}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;
